module.exports = __webpack_public_path__ + "static/images/d144e6e3a686bf3c92250067728d25e5.png";